import * as React from 'react';
import * as uuid from 'uuid';

function SvgEchIconsUxWater(props: React.SVGProps<SVGSVGElement>) {
  const iconUuid = uuid.v4();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <g>
        <linearGradient
          id={`${iconUuid}_c`}
          x1={61.767}
          x2={28.853}
          y1={97.927}
          y2={7.497}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={0.011} stopColor="#ec6608" />
          <stop offset={0.656} stopColor="#f18617" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_c)`}
          d="M54.7 7.6c-1.1-1.6-2.2-3.1-3.2-4.7l-2-2.9-2.3 3.3C34.2 21.4 19.7 42 16.7 59.7c-.4 2.6-.5 4.1-.5 5.1s-.1 2.2.1 3.9C18 86.5 32.5 100 49.9 100.1h.1c9.3 0 18.3-3.9 24.7-10.7 5.6-6 8.8-13.7 9.1-21.9V65c0-15.6-15.5-37.8-29.1-57.4zM71 86c-5.4 5.8-13.1 9.1-21 9.1h-.1c-14.6 0-27.2-11.8-28.6-26.9-.1-1.2-.1-2.1-.1-3.1v-.3c0-.7.2-3 .4-4.2 2.7-15.8 15.7-34.8 27.8-51.8.4.6.8 1.2 1.2 1.7 11.8 17 26.4 37.9 28 52l.1 2.6v1.2C78.8 73.6 76 80.6 71 86z"
        />
        <linearGradient
          id={`${iconUuid}_d`}
          x1={44.986}
          x2={35.583}
          y1={88.101}
          y2={62.266}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#ec6508" />
          <stop offset={0.011} stopColor="#ec6608" />
          <stop offset={0.656} stopColor="#f18617" />
          <stop offset={1} stopColor="#f3921c" />
        </linearGradient>
        <path
          fill={`url(#${iconUuid}_d)`}
          d="M34.6 64.5h-5c0 12.1 9.3 21.6 21.1 21.6v-5c-9.1-.1-16.1-7.4-16.1-16.6z"
        />
      </g>
    </svg>
  );
}
export default SvgEchIconsUxWater;
